export default {"src":"/_next/static/media/ad.57228d24.svg","height":398,"width":370};